module.exports = __webpack_public_path__ + "static/14-6-9403811b037f4f615430a40b5ce28a67.jpg";